export default __webpack_public_path__ + "static/media/analytics-marketing-team-6.6677d36b.svg";